module.exports = __webpack_public_path__ + "a5c0ee7889c71860bc7917e92a92ed62.svg";